const fr = {
  nav: {
    home: "Accueil", how: "Comment ça marche", licensing: "Licences", impact: "Impact & CO₂",
    contact: "Contact", cta: "Demander une licence", pseq2: "PSEQ2", menu: "Menu", close: "Fermer", logout: "Déconnexion", oracle: "Oracle",
  },
  admin: {
    title: "Panneau d'administration",
    licenses: "Demandes de licence",
    contacts: "Messages de contact",
    empty: "Rien ici pour le moment.",
    forbidden: "Accès réservé à l'équipe Dekrbat Pure.",
    statusT: "Statut",
    pending: "En attente",
    accepted: "Acceptée",
    rejected: "Refusée",
    accept: "Accepter",
    reject: "Refuser",
    loginFirst: "Connecte-toi avec un compte administrateur.",
    filterAll: "Toutes",
    reply: "Répondre",
    date: "Date",
  },
  oracle: {
    overline: "Oracle hors ligne",
    title: "Oracle Dekrbat — prédiction et constat en temps réel",
    sub: "Installe l'app : la météo de chaque zone se télécharge en arrière-plan. Graphiques, constats et rapports PDF fonctionnent hors ligne.",
    install: "Installer l'app",
    installing: "Utilise le menu du navigateur pour installer",
    online: "En ligne",
    offline: "Hors ligne — données en cache",
    syncing: "Synchronisation des zones",
    syncNow: "Synchroniser",
    lastSync: "Dernière synchro",
    never: "jamais",
    defaultZone: "Zone crevettière",
    scenarioZone: "Ton scénario",
    constatTitle: "Constat en direct",
    cachedAt: "Données du",
    verdicts: { validated: "Validé", partial: "Partiel", rejected: "Rejeté" },
    criteria: { temp: "Température", sunshine: "Ensoleillement", humidity: "Humidité", pressure: "Pression", co2: "CO₂" },
    predTitle: "Prédiction à 7 jours",
    weeklyPts: "PSEQ2 est. par bassin / semaine",
    chartTemp: "Temp max",
    chartSun: "Soleil",
    reportBtn: "Rapport PDF de zone",
    noData: "Pas encore de données pour cette zone — synchronise en ligne.",
    customZone: "Ma zone",
    addZoneTitle: "Ajouter ta zone",
    addZoneHint: "Clique sur la carte pour placer l'épingle, nomme ta zone, puis enregistre.",
    zoneNamePh: "Nom de la zone",
    saveZone: "Enregistrer",
    loginToAdd: "Connecte-toi pour enregistrer tes propres zones, brancher tes sondes et recevoir les alertes e-mail.",
    zoneSaved: "Zone enregistrée",
    zoneDeleted: "Zone supprimée",
    saveFailed: "Échec de l'enregistrement",
    deleteZone: "Supprimer",
    alertsOn: "Alertes e-mail activées",
    alertsOff: "Alertes e-mail désactivées",
    sensorConnect: "Connecter une sonde",
    sensorKeyOnce: "Clé API — copie-la maintenant, elle ne sera plus affichée.",
    sensorLive: "Sonde réelle",
    sensorOffline: "Sonde hors ligne",
    sensorCurl: "Exemple d'envoi depuis ta gateway",
    thresholdsTitle: "Seuils personnalisés",
    idealRange: "plage idéale",
    sunMin: "min (h)",
    thresholdsSaved: "Seuils enregistrés",
    sensorHistory: "Historique sonde",
    noSensorData: "Aucun relevé de sonde pour l'instant.",
    fieldMode: "Mode terrain",
    freshToday: "Données du jour",
    freshCache: "Cache du",
    tour: {
      replay: "Tutoriel",
      next: "Suivant",
      skip: "Passer",
      done: "Terminer",
      steps: [
        { t: "Bienvenue dans l'Oracle", b: "60 secondes pour maîtriser la surveillance de tes bassins. C'est parti !" },
        { t: "Statut de connexion", b: "Vert = en ligne, orange = hors ligne avec les données en cache. L'Oracle fonctionne même sans réseau." },
        { t: "Synchronisation", b: "Un clic télécharge la météo des 7 prochains jours pour toutes tes zones." },
        { t: "Mode terrain", b: "Gros boutons, contraste renforcé : lisible en plein soleil au bord des bassins." },
        { t: "Ta propre zone", b: "Clique sur la carte, nomme ta zone : elle sera surveillée comme les autres (connexion requise)." },
        { t: "Le verdict en un coup d'œil", b: "Validé, Partiel ou Rejeté : le constat météo du jour, avec tes sondes réelles si elles sont branchées." },
        { t: "Installe l'app", b: "Ajoute l'Oracle sur ton téléphone : il s'ouvre comme une application, même sans réseau." },
        { t: "C'est tout !", b: "Rejoue ce tutoriel à tout moment avec le bouton Tutoriel en haut de page." },
      ],
    },
  },
  landing: {
    overline: "Dossier déclassifié",
    title: "Un aliment vivant local pour la crevette juvénile de ta région.",
    sub: "Un système complet de production de microalgues qui relie producteurs artisanaux et écloseries de crevettes : chaîne courte, zéro dépendance aux importations, revenus qui restent sur place.",
    points: ["Production artisanale de microalgues vivantes", "Chaîne courte producteur → écloserie", "Des revenus qui restent dans ta région"],
    visitor: "Entrer en visiteur",
    google: "Continuer avec Google",
    divider: "ou avec ton e-mail",
    name: "Nom",
    email: "E-mail",
    password: "Mot de passe",
    loginBtn: "Se connecter",
    signupBtn: "Créer un compte",
    toSignup: "Pas de compte ? Créer un compte",
    toLogin: "Déjà un compte ? Se connecter",
    err: "Identifiants invalides ou e-mail déjà enregistré",
  },
  hero: {
    overline: "Né au Salvador · portée mondiale",
    lines: ["Un aliment vivant local", "pour la crevette juvénile,", "cultivé dans ta région."],
    sub: "Dekrbat Pure licencie un système complet de production de microalgues qui relie directement producteurs artisanaux et écloseries de crevettes — une chaîne courte qui réduit la dépendance aux intrants importés et transforme le CO₂ en points carbone vérifiés par capteurs.",
    ctaPrimary: "Demander une licence",
    ctaSecondary: "Voir comment ça marche",
    imageCaption: "Bassins de culture de microalgues",
    telemetryLabel: "Oracle de décarbonation",
    telemetryLive: "signal en direct",
    telemetryNote: "Flux conceptuel simulé",
    telemetryLines: [
      "capteur A-03 · CO₂ dissous · lecture vérifiée",
      "oracle · absorption naturelle validée",
      "point carbone émis · lot n°0182",
      "capteur B-11 · qualité de l'eau · paramètres stables",
      "oracle · télémétrie des bassins synchronisée",
      "point carbone émis · lot n°0183",
    ],
  },
  valprop: {
    overline: "La proposition",
    title: "Une chaîne courte remplace une chaîne importée",
    imported: {
      title: "Intrant importé",
      points: [
        "Parcourt des milliers de kilomètres jusqu'à l'écloserie",
        "Coûts exposés aux devises et à la logistique internationale",
        "Traçabilité limitée de l'origine biologique",
        "Une valeur économique qui quitte la région",
      ],
    },
    local: {
      title: "Réseau local Dekrbat Pure",
      points: [
        "Microalgues cultivées en bassins dans la région",
        "Livraison directe du producteur artisanal à l'écloserie",
        "Télémétrie par capteurs dans chaque bassin",
        "Emplois durables et valeur qui reste dans ta région",
      ],
    },
  },
  bento: {
    overline: "Le système",
    title: "Quatre pièces, un écosystème",
    items: {
      ponds: { title: "Bassins de culture", desc: "Infrastructure de production de microalgues pensée pour les conditions côtières et rurales." },
      coops: { title: "Réseau coopératif", desc: "Des producteurs artisanaux organisés approvisionnent directement les écloseries de leur région." },
      sensors: { title: "Capteurs en ligne", desc: "Suivi continu de la qualité de l'eau et du CO₂ dissous dans chaque bassin." },
      oracle: { title: "Oracle carbone", desc: "La télémétrie validée devient des points carbone en temps réel, traçables par lot." },
    },
  },
  marquee: [
    "Souveraineté alimentaire", "Zéro dépendance aux importations", "Traçabilité par capteurs",
    "Emplois locaux durables", "Points carbone en temps réel", "Chaîne courte",
  ],
  calc: {
    overline: "Modèle conceptuel",
    title: "Dimensionne ton réseau de bassins",
    desc: "Explore comment la télémétrie du système évolue avec la surface de culture.",
    sliderLabel: "Hectares de bassins de culture",
    unit: "ha",
    outputs: { volume: "Indice de production relative", datapoints: "Lectures capteurs par jour", points: "Points carbone émis par jour" },
    disclaimer: "Chiffres simulés, à titre illustratif uniquement. Ils ne représentent pas des performances réelles.",
  },
    xr: {
      overline: "Mode spatial",
      title: "Ta ferme en hologramme, autour de toi",
      sub: "Lunettes XREAL, Beam Pro ou simple écran : le simulateur PSEQ2 devient une maquette 3D spatiale — globe satellite, bassins en volume, météo réelle.",
    },
  ctaSection: {
    title: "Prêt à faire grandir l'avenir de la crevette ?",
    desc: "Rejoins le premier réseau licencié de microalgues pour la larviculture.",
    btn: "Demander une licence",
  },
  how: {
    hero: {
      overline: "Comment ça marche",
      title: "Du bassin à la larve, sans intermédiaires",
      sub: "Un écosystème en quatre étapes qui transforme eau, lumière et CO₂ en aliment vivant local — mesuré à chaque étape.",
    },
    steps: [
      { k: "Étape 01", title: "Construction & inoculation", desc: "Chaque site licencié installe ses bassins de culture et reçoit les souches de départ avec le protocole de production Dekrbat Pure." },
      { k: "Étape 02", title: "Croissance sous capteurs", desc: "Des sondes optiques et de CO₂ dissous enregistrent la qualité de l'eau et l'activité biologique en temps réel, bassin par bassin." },
      { k: "Étape 03", title: "Distribution locale directe", desc: "La récolte va du producteur artisanal à l'écloserie de la même région — une chaîne courte, sans importations." },
      { k: "Étape 04", title: "Validation par l'oracle", desc: "L'oracle de décarbonation valide l'absorption naturelle de CO₂ mesurée par capteurs et émet des points carbone traçables." },
    ],
    sensor: {
      overline: "Technologie",
      title: "Une télémétrie qui ne dort jamais",
      desc: "Chaque bassin licencié embarque un kit de capteurs qui transmet des lectures continues à l'oracle de décarbonation.",
      points: ["Sondes optiques de qualité de l'eau", "Capteurs de CO₂ dissous", "Transmission des données en temps réel", "Traçabilité par bassin et par lot"],
    },
    galleryCaptions: ["Inspection de larves de crevettes", "Échantillon de culture au laboratoire"],
  },
  licensing: {
    hero: {
      overline: "Licences",
      title: "Une licence pour chaque échelle de production",
      sub: "Dekrbat Pure licencie son système complet de production de microalgues auprès de coopératives et de sites individuels partout dans le monde.",
    },
    coop: {
      badge: "Coopératives",
      title: "Licence Coopérative",
      desc: "Modèle régional pour coopératives et associations de producteurs exploitant plusieurs fermes ou écloseries.",
      features: [
        "Couverture multi-fermes sous une seule licence",
        "Kits de capteurs alloués par bassin",
        "Protocoles de production et formation des équipes",
        "Accès coopératif au panneau de télémétrie de l'oracle",
        "Connexion avec les écloseries de la région",
      ],
    },
    site: {
      badge: "Sites individuels",
      title: "Licence Site",
      desc: "Déploiement sur mesure pour une installation unique : écloserie, ferme ou bassin pilote.",
      features: [
        "Licence dédiée à une seule installation",
        "Kit de capteurs dimensionné pour le site",
        "Mise en service assistée et inoculation initiale",
        "Télémétrie et points carbone propres au site",
        "Passerelle de croissance vers le modèle coopératif",
      ],
    },
    selectBtn: "Demander cette licence",
    form: {
      title: "Demande de licence",
      desc: "Parle-nous de ton exploitation et l'équipe Dekrbat Pure étudiera ta demande.",
      name: "Nom complet", org: "Coopérative ou entreprise", email: "E-mail", phone: "Téléphone",
      department: "Pays / Région", type: "Type de licence", typeCoop: "Coopérative", typeSite: "Site",
      ponds: "Nombre de bassins ou d'hectares", message: "Message (optionnel)",
      submit: "Envoyer la demande", sending: "Envoi…",
      success: "Demande reçue. L'équipe Dekrbat Pure l'étudiera rapidement.",
      error: "Envoi impossible. Réessaie.",
      selectPlaceholder: "Sélectionne une option",
    },
  },
  impact: {
    hero: {
      overline: "Impact & CO₂",
      title: "Chaque bassin mesure ce qu'il absorbe",
      sub: "Les microalgues capturent naturellement le CO₂ en grandissant. Dekrbat Pure mesure cette absorption par capteurs et la valide avec son oracle de décarbonation, générant des points carbone en temps réel.",
    },
    oracle: {
      overline: "L'oracle",
      title: "Du signal capteur au point carbone",
      desc: "L'architecture de mesure de Dekrbat Pure transforme la télémétrie biologique en registre vérifiable, sans déclarations externes.",
      flow: ["Bassins de microalgues", "Capteurs de CO₂", "Oracle de décarbonation", "Points carbone"],
      flowDescs: [
        "Absorption naturelle du CO₂ pendant la croissance",
        "Lectures continues du CO₂ dissous",
        "Validation de la télémétrie en temps réel",
        "Registre traçable par bassin et par lot",
      ],
    },
    telemetry: { title: "Télémétrie en direct", note: "Simulation conceptuelle du flux de données" },
    reel: {
      overline: "Histoire carbone",
      title: "Du bassin au point carbone, en mouvement",
      slides: [
        { k: "01 · Bassins", title: "Culture vivante", desc: "Les bassins de microalgues capturent le CO₂ naturellement tout en produisant de l'aliment vivant pour les écloseries." },
        { k: "02 · Capteurs", title: "Mesure continue", desc: "Sondes de CO₂ dissous et de qualité de l'eau enregistrent chaque bassin en temps réel." },
        { k: "03 · Oracle", title: "Validation", desc: "L'oracle de décarbonation valide la télémétrie en un registre vérifiable." },
        { k: "04 · Points", title: "Points carbone", desc: "Chaque validation émet des points carbone traçables par bassin et par lot." },
      ],
    },
    chain: {
      overline: "Chaîne de valeur",
      title: "Un impact en quatre dimensions",
      items: [
        { title: "Environnemental", desc: "Extraction naturelle du CO₂ mesurée par capteurs et validée par l'oracle, lot par lot." },
        { title: "Social", desc: "Emploi durable à long terme pour les producteurs artisanaux et les coopératives locales." },
        { title: "Économique", desc: "Résilience des écloseries grâce à une exposition réduite aux intrants importés." },
        { title: "Sécurité d'approvisionnement", desc: "Une nouvelle chaîne de valeur locale centrée sur les bassins de microalgues." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "Contact",
      title: "Parlons de ton projet",
      sub: "Écris-nous et l'équipe Dekrbat Pure te répondra. Tu peux aussi consulter les demandes enregistrées dans le système.",
    },
    form: {
      name: "Nom complet", email: "E-mail", subject: "Sujet", message: "Message",
      submit: "Envoyer le message", sending: "Envoi…",
      success: "Message envoyé et enregistré.", error: "Envoi impossible. Réessaie.",
    },
    drawer: {
      btn: "Voir les demandes enregistrées", title: "Demandes enregistrées", empty: "Aucune demande enregistrée pour le moment.",
      licenseTag: "Licence", contactTag: "Contact", close: "Fermer", loading: "Chargement…",
    },
  },
  intro: {
    dossier: "Dossier · Global", skip: "Cliquer pour passer",
    soundOn: "Son activé — cliquer pour couper", soundOff: "Son coupé",
  },
  story: {
    overline: "L'histoire",
    title: "Une économie solidaire née de l'eau",
    scenes: [
      { k: "Scène 01", title: "La valeur qui part", desc: "Pendant des années, l'aliment des écloseries arrivait importé : chaque achat envoyait des ressources hors de la région." },
      { k: "Scène 02", title: "Le producteur cultive", desc: "Les producteurs artisanaux élèvent des bassins de microalgues : eau, soleil et CO₂ deviennent aliment vivant." },
      { k: "Scène 03", title: "La coopérative connecte", desc: "La récolte part directement vers l'écloserie de la région. Sans intermédiaires ni importations : une chaîne courte." },
      { k: "Scène 04", title: "La valeur qui reste", desc: "Emplois locaux durables, revenus pour la coopérative et points carbone vérifiés par capteurs : l'économie grandit chez elle." },
    ],
  },
  pseq2: {
    overline: "Visualisation pré-installation",
    title: "PSEQ2 — Point de Séquestration de Seconde Génération",
    sub: "Avant d'installer tes bassins de microalgues, visualise le potentiel de décarbonation de n'importe quel point de la planète : la météo locale réelle alimente la simulation et chaque résultat apparaît dans un cube holographique.",
    config: {
      title: "Configure ton projet",
      bassins: "Nombre de bassins",
      bassinsFree: "Ou tape le nombre exact",
      surfaceFixed: "Surface par bassin : 100 m² — divisé en 4 unités indépendantes de 25 m² pour limiter la contamination croisée",
      totalSurface: "Surface totale",
      sun: "Couverture du site",
      sunFull: "Ouverte", sunMid: "Mixte", sunLow: "Ombragée",
      searchPlaceholder: "Rechercher une ville ou un lieu…",
      share: "Partager la simulation",
      shareCopied: "Lien copié dans le presse-papiers",
    },
    location: {
      title: "Localisation du projet",
      hint: "Clique sur la carte",
      loading: "Chargement de la météo locale…",
      error: "Météo indisponible à ce point",
      none: "Choisis un point sur la carte",
      satellite: "Satellite",
      mapLabel: "Plan",
      locate: "Ma position",
    },
    tour: {
      replay: "Tutoriel",
      next: "Suivant",
      skip: "Passer",
      done: "Terminer",
      steps: [
        { t: "Bienvenue dans le simulateur PSEQ2", b: "Une minute pour estimer ta production locale d'aliment vivant. C'est parti !" },
        { t: "Nombre de bassins", b: "Fais glisser le curseur : chaque bassin est une unité indépendante de 100 m² qui limite la contamination croisée." },
        { t: "Régime solaire", b: "Plein ciel, mixte ou ombragé : la lumière pilote la croissance des microalgues." },
        { t: "Localisation du projet", b: "Clique sur la carte ou utilise Ma position : le simulateur charge la météo réelle du lieu." },
        { t: "Le cube holographique", b: "Tes résultats en 3D : points PSEQ2, CO₂ capté, aliment local et emplois. Fais-le tourner au doigt." },
        { t: "Rapport PDF", b: "Exporte un rapport complet de ton scénario, prêt à partager avec ta coopérative." },
        { t: "Partager la simulation", b: "Un clic copie un lien avec une carte satellite d'aperçu pour WhatsApp et les réseaux." },
        { t: "C'est prêt !", b: "Rejoue ce tutoriel à tout moment avec le bouton Tutoriel." },
      ],
    },
    weather: { temp: "Température", humidity: "Humidité", pressure: "Pression", sunshine: "Soleil par jour", hours: "h" },
    rating: {
      title: "Verdict d'installation",
      basis: "Calculé à partir de la météo locale réelle : température, soleil, humidité et pression",
      levels: ["Non recommandé", "Passable", "Correct", "Bon", "Super"],
    },
    cubes: {
      pseq2: { label: "PSEQ2 potentiel", unit: "pts / an" },
      co2: { label: "CO₂ séquestré", unit: "t / an" },
      feed: { label: "Aliment vivant local", unit: "indice" },
      jobs: { label: "Emplois locaux", unit: "rôles" },
    },
    preview: {
      title: "Aperçu du rapport",
      config: "Configuration",
      weather: "Météo locale",
      capacity: "Résumé de capacité",
      contaminationTitle: "Confinement de la contamination",
      contaminationText: "Chaque bassin de 100 m² est divisé en 4 unités indépendantes de 25 m² : si un foyer apparaît, seule cette unité est isolée et mise en quarantaine — le reste de la production continue.",
    },
    history: {
      title: "Historique des scénarios",
      save: "Enregistrer le scénario",
      saved: "Scénario enregistré",
      error: "Impossible d'enregistrer le scénario",
      empty: "Aucun scénario enregistré : configure et enregistre ta première simulation.",
      exportPdf: "Exporter en PDF",
      publish: "Publier",
      unpublish: "Retirer",
      sharedTag: "Public",
      tabAll: "Tous",
      tabPublic: "Publics",
      date: "Date",
    },
    disclaimer: "Modèle conceptuel de prévisualisation : valeurs simulées à partir de la météo locale réelle — ni une mesure ni un engagement de performance.",
    what: {
      overline: "Définition",
      title: "Qu'est-ce qu'un PSEQ2 ?",
      desc: "Le PSEQ2 — Point de Séquestration de Seconde Génération — est l'unité que l'oracle de décarbonation Dekrbat Pure émet lorsque la télémétrie des capteurs valide la capture naturelle du CO₂ par les microalgues.",
      cards: [
        { title: "Mesuré", desc: "Sondes de CO₂ dissous et de qualité de l'eau en continu dans chaque bassin." },
        { title: "Validé", desc: "L'oracle vérifie la télémétrie en temps réel, bassin par bassin, lot par lot." },
        { title: "Émis", desc: "Chaque validation génère un PSEQ2 traçable, visible dans tes cubes holographiques." },
      ],
    },
    cta: {
      title: "Passe de la simulation au bassin réel",
      desc: "Demande ta licence et transforme ces cubes holographiques en télémétrie vivante.",
      btn: "Demander une licence",
    },
    teaser: {
      overline: "Nouveau",
      title: "Visualise avant d'installer",
      desc: "Le simulateur PSEQ2 projette le potentiel de décarbonation de tes futurs bassins dans des cubes holographiques 3D, alimentés par la météo locale réelle.",
      btn: "Ouvrir le simulateur",
    },
    report: {
      btn: "Télécharger le rapport PDF",
      title: "Rapport de simulation PSEQ2",
      config: "Configuration",
      capacity: "Resume de capacite",
      weatherT: "Meteo locale",
      ratingT: "Verdict",
      bassins: "Nombre de bassins",
      surfaceFixed: "Surface par bassin: 100 m2 (4 unites independantes de 25 m2, risque de contamination croisee limite)",
      totalSurface: "Surface totale (m2)",
      contaminationTitle: "Confinement de la contamination",
      contaminationText: "Chaque bassin de 100 m2 est divise en 4 unites independantes de 25 m2: si un foyer apparait, seule cette unite est isolee et mise en quarantaine; le reste de la production continue.",
      sun: "Couverture du site",
      locationT: "Localisation",
      date: "Genere le",
      footer: "Dekrbat Pure · Modele conceptuel de previsualisation — valeurs simulees, sans engagement de performance.",
    },
  },
  footer: {
    tagline: "Systèmes locaux de culture de microalgues pour la larviculture de la crevette, du Salvador vers le monde.",
    nav: "Navigation",
    location: "Salvador, Amérique centrale",
    rights: "Tous droits réservés.",
  },
};

export default fr;
